// libs
import { styled } from '@nykaa/ui-components';

// component
import RippleIt from 'shared/components/RippleIt';

// constants
import { MOBILE_NAVIGATION_HEIGHT, BREAKPOINTS } from 'shared/styles/base';

export const Wrapper = styled.header<{ showBorder: boolean }>`
  width: 100%;
  height: ${MOBILE_NAVIGATION_HEIGHT}px;
  position: fixed;
  top: 0;
  @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
    left: 0;
  }
  display: flex;
  align-items: center;
  background: #fff;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing100}`};
  ${({ theme }) => theme.typography.type201};
  z-index: 1;
  ${({ showBorder, theme }) => showBorder && `border: solid 1px ${theme.colors.surface20};`}

  .navigation__title {
    display: inline-block;
    height: 24px;
  }
`;

export const Icon = styled(RippleIt)`
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.spacing80};
  border-radius: ${({ theme }) => theme.borders.radiusFull};
`;
